import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { telemetryAPI } from "../../../api/api";
import { parseTelemetry } from "../../../api/telemetryparser";
import Gauge from "../../Gauge/Gauge";
import Tank from "../../Tank/Tank";
// import StatusTile from "./StatusTile";
import PumpCard from "../../StatusTile/StatusTile";
import "../../../Dashboard.css";
// import SystemIndicator from "./SystemHealth";
import { useNavigate } from "react-router-dom"; // Don't forget this!
// import { ArrowLeft } from "lucide-react";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;




export default function Dashboard_2() {
  const navigate = useNavigate();
  const { siteId: assetId } = useParams();
  const [devices, setDevices] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState("");
  const [data, setData] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false); // New state to track completion

  useEffect(() => {
    const loadDevices = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const res = await fetch(
          `${API_BASE_URL}/api/relations/info?fromId=${assetId}&fromType=ASSET`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        const relations = await res.json();
        const siteDevices = relations
          .filter(r => r.to.entityType === "DEVICE")
          .map(r => ({ id: r.to.id, name: r.toName }));

        setDevices(siteDevices);

        if (siteDevices.length > 0) {
          setSelectedDevice(siteDevices[0].id);
        } else {
          setIsLoaded(true); // Stop loading if no devices exist
        }
      } catch (err) {
        console.error("Device load error:", err);
        setIsLoaded(true);
      }
    };
    loadDevices();
  }, [assetId]);

  useEffect(() => {
    if (!selectedDevice) return;
    const loadTelemetry = async () => {
      const res = await telemetryAPI(selectedDevice);
    
      setData(parseTelemetry(res));
      setIsLoaded(true);
    };
    loadTelemetry();
    const i = setInterval(loadTelemetry, 60000);
    return () => clearInterval(i);
  }, [selectedDevice]);

  const renderGroup = (cat, title) => {
    if (!data) return null;
    const groupData = data.status.filter(s => s.category === cat);
    if (groupData.length === 0) return null;
    return <PumpCard title={title} stats={groupData} />;
  };

  return (

<div className="dashboard-container">
  <div className="alarms-header-main">
    <div className="title-block">
      {/* Back Button styled as a technical action square */}
      <button className="back-btn-square" onClick={() => navigate(-1)}>
        <ArrowBackIosNewIcon sx={{ fontSize: 16 }} />
      </button>
      
<div className="header-text-group">
  <h1>Site Data Monitoring</h1>
  <div className="sub-header">
    <div className="status-dot active"></div>
    {/* Display the formatted timestamp here */}
   <span>{data?.lastUpdated && `Last Updated: ${data?.lastUpdated}`}</span>
  </div>
</div>
    </div>

    {/* <div className="controls-block">
        <div className="site-select-wrapper">
            <select
              value={selectedDevice}
              onChange={e => setSelectedDevice(e.target.value)}
              disabled={devices.length === 0}
            >
              {devices.length === 0 ? <option>No devices found</option> : 
                devices.map(d => <option key={d.id} value={d.id}>{d.name}</option>)
              }
            </select>
        </div>
    </div> */}
  </div>

      {/* 3. Conditional Content Handling */}
      {!isLoaded ? (
        <div className="loading">Initializing System Monitoring...</div>
      ) : devices.length === 0 ? (
        <div style={{ textAlign: 'center', padding: '50px', color: '#64748b', }}>
          <h3>No Devices Assigned</h3>
          <p>Please assign a device to this site to view telemetry data.</p>
        </div>
      ) : !data ? (
        <div className="loading">Fetching Telemetry Data...</div>
      ) : (
        <>
          <div className="gauges" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '20px', marginBottom: '40px' }}>
            <Gauge value={data.pressures.upperHyd} label="Upper Hydrant" />
            <Gauge value={data.pressures.lowerHyd} label="Lower Hydrant" />
            <Gauge value={data.pressures.upperSpr} label="Upper Sprinkler" />
            <Gauge value={data.pressures.lowerSpr} label="Lower Sprinkler" />
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '20px', alignItems: 'stretch',cursor: 'default' }}>
            {renderGroup("hydrant", "Hydrant Pump")}
            {renderGroup("hyd_jockey", "Hyd Jockey Pump")}
            {renderGroup("sprinkler", "Sprinkler Pump")}
            {renderGroup("spr_jockey", "Spr Jockey Pump")}
            {renderGroup("engine", "Diesel Engine Pump")}
            {renderGroup("system", "OTHER INDICATIONS")}
          </div>

          <h2 style={{ fontSize: '1.5rem', fontWeight: 'bold', marginTop: '40px', marginBottom: '20px', color: '#1e293b' }}>
            Tank Levels
          </h2>
          <div style={{ display: 'flex', justifyContent: 'space-around', flexWrap: 'wrap', background: '#fff', padding: '30px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
            {data.tanks.map((tank, i) => (
              <Tank key={i} {...tank} />
            ))}
          </div>
        </>
      )}
    </div>
  );
}